import { CommonValidationMessages } from "../../../utils/Messages";

export const CPASScoringSheetValidationRules = {
    candidateName: [
        {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
                "{0}",
                "Candidate Name"
            ),
        },
    ],

    preAssessmentScore: [
        {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
                "{0}",
                "Pre-Assessment Score"
            ),
        },
    ],

   

    comment: [
        {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
                "{0}",
                "Comment"
            ),
        },
    ],

    assessorName: [
        {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
                "{0}",
                "Assessor Name"
            ),
        },
    ],

    dateofAssessment: [
        {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
                "{0}",
                "Date of Assessment"
            ),
        },
        {
            type: "isMaximumDate",
            message: "Date of assessment must be earlier than 31 Dec 9999",
        },
        {
            type: "isMinDate",
            message: "Please check your date of assessment",
        },
    ],

    filePath: [
        {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
                "{0}",
                "Upload Written Report"
            ),
        },
    ],
};
